import Lives from './Lives';

export default Lives;
